import React from 'react';

export const CoffeeCheckoutHeading = () => {
  return <>To get the scale, buy your first bag</>;
};
